module["exports"] = [
  "#{street_suffix} #{Name.first_name}",
  "#{street_suffix} #{Name.last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/street_name.js
// module id = 730
// module chunks = 0